import { observer, inject } from "mobx-react";
import { FC, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import Store from "./store";
import { ClientDto } from "./types";
import * as _ from "lodash";
import Button from "../../../components/Button";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { toast } from "react-toastify";
import { MessageResultState } from "../../../types/general-types";
import cx from "classnames";
import { useForm } from "react-hook-form";

interface IPage {
  ClientManagementStore?: Store;
  isShow: boolean;
  toggleModal: any;
  selectedRow: ClientDto | undefined;
  setSelectedRow: any;
  clients: ClientDto[];
  setClients: any;
}
const ClientManagementPage: FC<IPage> = inject("ClientManagementStore")(
  observer((props: IPage) => {
    const {
      ClientManagementStore: store,
      isShow,
      toggleModal,
      selectedRow,
      setSelectedRow,
      clients,
      setClients,
    } = props;

    const { register, control, handleSubmit, errors } = useForm();
    const { t } = useTranslation();

    const [typingTimeout, setTypingTimeout] = useState<NodeJS.Timeout | null>(
      null
    );

    const page = useMemo(() => {
      return (
        <>
          <div className="row mb-2">
            <div className="col-md-6">
              <div className="">
                <label style={{}} htmlFor="name">
                  {t("Name")} <strong className="text-danger">*</strong>
                </label>
              </div>

              <input
                type="text"
                value={selectedRow?.name}
                name={"title"}
                placeholder={t("Client Title")}
                ref={register({
                  required: t("Please fill out this field.").toString(),
                })}
                className={cx("form-control ", {
                  "is-invalid": errors["title"],
                })}
                onChange={(event: any) => {
                  console.log("onChange", event.target.value);
                  setSelectedRow({
                    ...selectedRow,
                    name: event.target.value,
                  });
                  if (typingTimeout) {
                    clearTimeout(typingTimeout);
                  }
                  const timeout = setTimeout(() => {
                    console.log("translateText", event.target.value);

                    if (event.target.value && event.target.value.length > 2)
                      store
                        ?.Translation(event.target.value)
                        .then((response) => {
                          if (response.state === MessageResultState.SUCCESS) {
                            setSelectedRow({
                              ...selectedRow,
                              name_EN: response.result,
                              name: event.target.value,
                            });
                          }
                        });

                    // translateText(event.target.value);
                  }, 1000);
                  setTypingTimeout(timeout);
                }}
              />
            </div>
            <div className="col-md-6">
              <div className="">
                <label style={{}} htmlFor="name">
                  {t("Name")} (EN) <strong className="text-danger">*</strong>
                </label>
              </div>
              <input
                type="text"
                value={selectedRow?.name_EN}
                name={"title_EN"}
                placeholder={t("Client Title")}
                ref={register({
                  required: t("Please fill out this field.").toString(),
                })}
                className={cx("form-control ", {
                  "is-invalid": errors["title_EN"],
                })}
                onChange={(event: any) => {
                  setSelectedRow({
                    ...selectedRow,
                    name_EN: event.target.value,
                  });
                }}
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6">
              <div className="">
                <label style={{}} htmlFor="description">
                  {t("Description")}
                  <strong className="text-danger">*</strong>
                </label>
              </div>
              <textarea
                value={selectedRow?.description}
                name={"description"}
                placeholder={t("Client Description")}
                ref={register({
                  required: t("Please fill out this field.").toString(),
                })}
                className={cx("form-control ", {
                  "is-invalid": errors["description"],
                })}
                onChange={(event: any) => {
                  console.log("onChange", event.target.value);
                  setSelectedRow({
                    ...selectedRow,
                    description: event.target.value,
                  });
                  if (typingTimeout) {
                    clearTimeout(typingTimeout);
                  }
                  const timeout = setTimeout(() => {
                    console.log("translateText", event.target.value);
                    if (event.target.value && event.target.value.length > 2)
                      store
                        ?.Translation(event.target.value)
                        .then((response) => {
                          if (response.state === MessageResultState.SUCCESS) {
                            setSelectedRow({
                              ...selectedRow,
                              description_EN: response.result,
                              description: event.target.value,
                            });
                          }
                        });
                  }, 1000);
                  setTypingTimeout(timeout);
                }}
              />
            </div>
            <div className="col-md-6">
              <div className="">
                <label style={{}} htmlFor="description">
                  {t("Description")} (EN)
                  <strong className="text-danger">*</strong>
                </label>
              </div>
              <textarea
                value={selectedRow?.description_EN}
                name={"description_EN"}
                placeholder={t("Client Description")}
                ref={register({
                  required: t("Please fill out this field.").toString(),
                })}
                className={cx("form-control ", {
                  "is-invalid": errors["description_EN"],
                })}
                onChange={(event) => {
                  setSelectedRow({
                    ...selectedRow,
                    description_EN: event.target.value,
                  });
                }}
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6">
              <div className="">
                <label style={{}} htmlFor="redirectUri">
                  {t("Redirect Uri")}
                  <strong className="text-danger">*</strong>
                </label>
              </div>
              <textarea
                value={selectedRow?.redirectUri}
                name={"redirectUri"}
                placeholder={t("Redirect Uri")}
                ref={register({
                  required: t("Please fill out this field.").toString(),
                })}
                className={cx("form-control ", {
                  "is-invalid": errors["redirectUri"],
                })}
                onChange={(event) => {
                  setSelectedRow({
                    ...selectedRow,
                    redirectUri: event.target.value,
                  });
                }}
              />
            </div>

            <div className="col-md-6">
              <div className="">
                <label style={{}} htmlFor="logoutUri">
                  {t("Logout Uri")}
                  <strong className="text-danger">*</strong>
                </label>
              </div>
              <textarea
                value={selectedRow?.logoutUri}
                name={"logoutUri"}
                placeholder={t("Logout Uri")}
                ref={register({
                  required: t("Please fill out this field.").toString(),
                })}
                className={cx("form-control ", {
                  "is-invalid": errors["logoutUri"],
                })}
                onChange={(event) => {
                  setSelectedRow({
                    ...selectedRow,
                    logoutUri: event.target.value,
                  });
                }}
              />
            </div>
          </div>
          <div className="row mb-2">
            <div className="col-md-6">
              <div className="">
                <label style={{}} htmlFor="permissionPrefix">
                  {t("Permission Prefix")}
                  <strong className="text-danger">*</strong>
                </label>
              </div>
              <textarea
                value={selectedRow?.permissionPrefix}
                name={"permissionPrefix"}
                placeholder={t("Permission Prefix")}
                ref={register({
                  required: t("Please fill out this field.").toString(),
                })}
                className={cx("form-control ", {
                  "is-invalid": errors["permissionPrefix"],
                })}
                onChange={(event) => {
                  setSelectedRow({
                    ...selectedRow,
                    permissionPrefix: event.target.value,
                  });
                }}
              />
            </div>
            <div className="col-md-3">
              <div className="">
                <label style={{}} htmlFor="isLocal">
                  {t("Appearance Order")}
                  <strong className="text-danger">*</strong>
                </label>
              </div>
              <input
                type="number"
                value={selectedRow?.orderIndex}
                name={"orderIndex"}
                placeholder={t("Appearance Order")}
                ref={register({
                  required: t("Please fill out this field.").toString(),
                })}
                className={cx("form-control ", {
                  "is-invalid": errors["orderIndex"],
                })}
                onChange={(event: any) => {
                  setSelectedRow({
                    ...selectedRow,
                    orderIndex: event.target.value,
                  });
                }}
              />
            </div>
            <div className="col-md-3">
              <div className="">
                <label style={{}} htmlFor="isLocal">
                  {t("Is Local")}
                </label>
              </div>
              <input
                type={"checkbox"}
                style={{ width: "30px", height: "30px" }}
                // className={"form-control"}
                checked={selectedRow?.isLocal}
                onChange={(event) => {
                  setSelectedRow({
                    ...selectedRow,
                    isLocal: event.target.checked,
                  });
                }}
              />
            </div>
          </div>
        </>
      );
    }, [selectedRow, errors, clients]);

    const update = async () => {
      if (selectedRow) {
        const response = await store!.update(selectedRow).then((res) => {
          if (res.state === MessageResultState.SUCCESS) {
            let client = clients.find((x) => x.id === selectedRow.id);
            store?.getAll().then((res) => {
              if (res.state === MessageResultState.SUCCESS) {
                setClients(res.result);
                toggleModal();
              }
            });
          }
        });
        return response;
      } else {
        toast.error(t("Error"));
      }
    };

    const create = async () => {
      if (selectedRow) {
        await store!.create(selectedRow).then((res) => {
          if (res.state === MessageResultState.SUCCESS) {
            store?.getAll().then((res) => {
              if (res.state === MessageResultState.SUCCESS) {
                setClients(res.result);
                toggleModal();
              }
            });
          }
        });
      } else {
        toast.error(t("Error"));
      }
    };

    return (
      <Modal
        size="xl"
        isOpen={isShow}
        toggle={toggleModal}
        backdrop="static"
        className="modal-lg"
      >
        <ModalHeader toggle={toggleModal}>{t("Add New Portal")}</ModalHeader>
        <ModalBody>{page}</ModalBody>
        <ModalFooter>
          <button className="btn btn-light mr-auto" onClick={toggleModal}>
            <i className="fas fa-times mr-2"></i>
            {t("Close")}
          </button>
          {
            <Button
              showConfirm={true}
              className="btn ml-2"
              style={{
                backgroundColor: "#23486A",
                color: "#faf5f5",
              }}
              onClick={
                selectedRow?.id && selectedRow?.id !== ""
                  ? handleSubmit(update)
                  : handleSubmit(create)
              }
              icon={<i className="far fa-save mr-2"></i>}
              text={t("Save")}
            />
          }
        </ModalFooter>
      </Modal>
    );
  })
);

export default ClientManagementPage;
